"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _imagepreview = _interopRequireDefault(require("./imagepreview/imagepreview"));

var _icon = _interopRequireDefault(require("../graphic/icon/icon"));

var _button = _interopRequireDefault(require("../ctas/cta/button/button"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _imageuploader_styles = _interopRequireDefault(require("./imageuploader_styles"));

var _imageuploader_definition = _interopRequireDefault(require("./imageuploader_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : IMAGE UPLOADER ~~~~~~~~~~ ========== */


var ImageUploader = (0, _reactJss.default)(_imageuploader_styles.default)(function (props) {
  var handleImageUpload = function handleImageUpload(e) {
    var file = e.target.files[0];

    if (file) {
      var img = new Image();

      img.onload = function () {
        if (this.height > props.maxHeight || this.width > props.maxWidth) {
          return props.sendErrorMessage("Image cant be larger than ".concat(props.maxHeight, " x ").concat(props.maxWidth));
        }

        if (file.size > props.maxSize * 1000) {
          props.sendErrorMessage("This image is too large. File size must be under ".concat(props.maxSize / 1000, "MB."));
          return null;
        }

        if (!props.supportedFileTypes.includes(file.type)) {
          props.sendErrorMessage('File type not supported. Please use PNG, JPEG');
          return null;
        }

        var reader = new FileReader();
        reader.addEventListener('load', function () {
          fetch(reader.result).then(function (res) {
            return res.blob();
          }).then(function (blob) {
            blob.name = file.name;
            props.uploadImage(blob);
          });
        }, false);
        reader.readAsDataURL(file);
      };

      img.src = URL.createObjectURL(file);
    }
  };

  return _react.default.createElement("div", {
    className: "imageuploader ".concat(props.classes.imageuploader, " uploading-").concat(props.uploading || !!props.imageSrc)
  }, _react.default.createElement("div", {
    className: 'inputbutton'
  }, _react.default.createElement(_button.default, {
    text: 'Upload image...',
    operation: 'upload',
    processing: props.uploading,
    disabled: !!props.imageSrc,
    variant: 'system'
  }), _react.default.createElement("input", {
    className: "mainImageInput",
    value: null,
    type: "file",
    onChange: handleImageUpload
  })), _react.default.createElement(_imagepreview.default, {
    imgSrc: props.imageSrc,
    fileName: props.fileName,
    uploading: props.uploading,
    discardFile: props.discardFile
  }));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(ImageUploader, _imageuploader_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = ImageUploader;
exports.default = _default;